// import { useEffect, useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import { Modal, Button, Form, InputGroup, Pagination, Spinner } from "react-bootstrap";
// import {
//   managerQueue,
//   managerApprove,
//   managerReqChg,
//   managerReject,
// } from "../../api";
// import "./ManagerQueue.css";

// const fakeManager = { id: 11, unit_id: 3 };

// export default function ManagerQueue() {
//   const [rows, setRows] = useState([]);
//   const [comment, setComment] = useState("");

//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [actionModal, setActionModal] = useState({
//     show: false,
//     id: null,
//     type: "",
//     title: "",
//   });

//   useEffect(() => {
//     load();
//   }, []);

//   useEffect(() => {
//     setPage(1);
//   }, [search, rowsPerPage]);

//   async function load() {
//     try {
//       setLoading(true);
//       const { data } = await managerQueue({
//         unit_id: fakeManager.unit_id,
//       });

//       setRows(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Manager Queue Error:", error);
//       alert(error?.response?.data?.error || "Failed to load manager queue");
//     } finally {
//       setLoading(false);
//     }
//   }

//   const filteredRows = useMemo(() => {
//     const q = search.trim().toLowerCase();

//     if (!q) return rows;

//     return rows.filter((row) => {
//       return [
//         row.code,
//         row.title,
//         row.requester,
//         row.total_amount,
//         row.submitted_at,
//       ]
//         .filter(Boolean)
//         .some((value) => String(value).toLowerCase().includes(q));
//     });
//   }, [rows, search]);

//   const totalPages = Math.max(1, Math.ceil(filteredRows.length / rowsPerPage));

//   const pageData = useMemo(() => {
//     const start = (page - 1) * rowsPerPage;
//     return filteredRows.slice(start, start + rowsPerPage);
//   }, [filteredRows, page, rowsPerPage]);

//   const totalAmount = useMemo(() => {
//     return filteredRows.reduce(
//       (sum, row) => sum + Number(row.total_amount || 0),
//       0
//     );
//   }, [filteredRows]);

//   const openActionModal = (id, type) => {
//     const titleMap = {
//       approve: "Approve Report",
//       request: "Request Changes",
//       reject: "Reject Report",
//     };

//     setActionModal({
//       show: true,
//       id,
//       type,
//       title: titleMap[type] || "Confirm Action",
//     });
//   };

//   const closeActionModal = () => {
//     setActionModal({
//       show: false,
//       id: null,
//       type: "",
//       title: "",
//     });
//   };

//   async function confirmAction() {
//     const { id, type } = actionModal;

//     if (!id || !type) return;

//     try {
//       setSaving(true);

//       if (type === "approve") {
//         await managerApprove(id, {
//           actor_id: fakeManager.id,
//           comment,
//         });
//       }

//       if (type === "request") {
//         await managerReqChg(id, {
//           actor_id: fakeManager.id,
//           comment: comment || "Please correct details",
//         });
//       }

//       if (type === "reject") {
//         await managerReject(id, {
//           actor_id: fakeManager.id,
//           comment: comment || "Not acceptable",
//         });
//       }

//       setComment("");
//       closeActionModal();
//       await load();

//       alert("Action completed successfully");
//     } catch (error) {
//       console.error("Manager Action Error:", error);
//       alert(error?.response?.data?.error || "Failed to complete action");
//     } finally {
//       setSaving(false);
//     }
//   }

//   const exportCSV = () => {
//     if (!filteredRows.length) {
//       alert("No data available to export");
//       return;
//     }

//     const headers = [
//       "ID",
//       "Code",
//       "Title",
//       "Requester",
//       "Total Amount",
//       "Submitted At",
//     ];

//     const csvRows = filteredRows.map((row) => [
//       row.id,
//       row.code,
//       row.title,
//       row.requester,
//       Number(row.total_amount || 0).toFixed(2),
//       row.submitted_at ? new Date(row.submitted_at).toLocaleString() : "-",
//     ]);

//     const csvContent = [headers, ...csvRows]
//       .map((row) =>
//         row
//           .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
//           .join(",")
//       )
//       .join("\n");

//     const blob = new Blob([csvContent], {
//       type: "text/csv;charset=utf-8;",
//     });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");

//     link.href = url;
//     link.download = "manager-queue.csv";
//     link.click();

//     URL.revokeObjectURL(url);
//   };

//   const clearFilters = () => {
//     setSearch("");
//     setComment("");
//     setRowsPerPage(10);
//     setPage(1);
//   };

//   const formatDate = (date) => {
//     if (!date) return "-";
//     return new Date(date).toLocaleString();
//   };

//   return (
//     <div className="unit-page acct-managerqueue-theme">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Accounts Approval</div>
//           <h2>Manager Queue</h2>
//           <p>Review submitted reports, approve them, request changes or reject.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={load}>
//             Refresh
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
//             Export CSV
//           </Button>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <span>Total Pending</span>
//           <strong>{rows.length}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Filtered Result</span>
//           <strong>{filteredRows.length}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Total Amount</span>
//           <strong>₹{totalAmount.toFixed(2)}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Current Page</span>
//           <strong>{page}</strong>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>Pending Reports</h5>
//             <p>Search report, add comment, and perform approval actions.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             <InputGroup className="unit-search">
//               <InputGroup.Text>⌕</InputGroup.Text>

//               <Form.Control
//                 placeholder="Search code, title, requester, amount..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />

//               {search && (
//                 <Button className="unit-clear-btn" onClick={() => setSearch("")}>
//                   Clear
//                 </Button>
//               )}
//             </InputGroup>

//             <Form.Select
//               className="unit-page-size"
//               value={rowsPerPage}
//               onChange={(e) => setRowsPerPage(Number(e.target.value))}
//             >
//               <option value={5}>5 rows</option>
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>

//             {(search || comment || rowsPerPage !== 10) && (
//               <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
//                 Reset
//               </Button>
//             )}
//           </div>
//         </div>

//         <div className="p-3 border-bottom">
//           <Form.Group>
//             <Form.Label>Comment for Next Action</Form.Label>
//             <Form.Control
//               placeholder="Optional comment for approve / request changes / reject..."
//               value={comment}
//               onChange={(e) => setComment(e.target.value)}
//             />
//             <small className="text-muted">
//               This comment will be sent with the action you choose.
//             </small>
//           </Form.Group>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading manager queue...</p>
//             </div>
//           ) : (
//             <table className="table unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: "90px" }}>Code</th>
//                   <th>Report</th>
//                   <th>Requester</th>
//                   <th>Total</th>
//                   <th>Submitted</th>
//                   <th className="text-end" style={{ width: "280px" }}>
//                     Actions
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {pageData.length > 0 ? (
//                   pageData.map((row) => (
//                     <tr key={row.id}>
//                       <td>
//                         <span className="unit-id">{row.code || `#${row.id}`}</span>
//                       </td>

//                       <td>
//                         <div className="unit-name-box">
//                           <div className="unit-letter">
//                             {row.title?.charAt(0)?.toUpperCase() || "R"}
//                           </div>

//                           <div>
//                             <Link
//                               to={`/admin/accounts/reports/${row.id}`}
//                               className="text-decoration-none"
//                             >
//                               <strong>{row.title || "-"}</strong>
//                             </Link>
//                             <small>Report ID: {row.id}</small>
//                           </div>
//                         </div>
//                       </td>

//                       <td>{row.requester || "-"}</td>

//                       <td>
//                         <span className="unit-id">
//                           ₹{Number(row.total_amount || 0).toFixed(2)}
//                         </span>
//                       </td>

//                       <td>{formatDate(row.submitted_at)}</td>

//                       <td>
//                         <div className="unit-actions">
//                           <Button
//                             className="unit-btn unit-btn-primary"
//                             onClick={() => openActionModal(row.id, "approve")}
//                           >
//                             Approve
//                           </Button>

//                           <Button
//                             className="unit-btn unit-btn-light"
//                             onClick={() => openActionModal(row.id, "request")}
//                           >
//                             Changes
//                           </Button>

//                           <Button
//                             className="unit-btn unit-btn-danger"
//                             onClick={() => openActionModal(row.id, "reject")}
//                           >
//                             Reject
//                           </Button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="6">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">□</div>
//                         <h5>No pending reports</h5>
//                         <p>There are no reports waiting for manager review.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>{filteredRows.length === 0 ? 0 : (page - 1) * rowsPerPage + 1}</strong>{" "}
//             to <strong>{Math.min(page * rowsPerPage, filteredRows.length)}</strong>{" "}
//             of <strong>{filteredRows.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={page === 1}
//                 onClick={() => setPage((prev) => Math.max(1, prev - 1))}
//               />

//               {[...Array(totalPages)].map((_, index) => (
//                 <Pagination.Item
//                   key={index + 1}
//                   active={index + 1 === page}
//                   onClick={() => setPage(index + 1)}
//                 >
//                   {index + 1}
//                 </Pagination.Item>
//               ))}

//               <Pagination.Next
//                 disabled={page === totalPages}
//                 onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={actionModal.show}
//         onHide={closeActionModal}
//         centered
//         className="unit-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{actionModal.title}</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <p className="unit-delete-text">
//             Are you sure you want to continue with this action?
//           </p>

//           <Form.Group className="mt-3">
//             <Form.Label>Comment</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               placeholder="Add comment..."
//               value={comment}
//               onChange={(e) => setComment(e.target.value)}
//             />
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeActionModal}>
//             Cancel
//           </Button>

//           <Button
//             className={
//               actionModal.type === "reject"
//                 ? "unit-btn unit-btn-danger"
//                 : actionModal.type === "request"
//                 ? "unit-btn unit-btn-light"
//                 : "unit-btn unit-btn-primary"
//             }
//             onClick={confirmAction}
//             disabled={saving}
//           >
//             {saving ? "Saving..." : "Confirm"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }









import { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { Link } from "react-router-dom";
import {
  Modal,
  Button,
  Form,
  InputGroup,
  Pagination,
  Spinner,
} from "react-bootstrap";
import {
  managerQueue,
  managerApprove,
  managerReqChg,
  managerReject,
} from "../../api";
import "./ManagerQueue.css";

const fakeManager = { id: 11, unit_id: 3 };

export default function ManagerQueue() {
  const [rows, setRows] = useState([]);
  const [comment, setComment] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [actionModal, setActionModal] = useState({
    show: false,
    id: null,
    type: "",
    title: "",
  });

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [search, rowsPerPage]);

  async function load() {
    try {
      setLoading(true);

      const { data } = await managerQueue({
        unit_id: fakeManager.unit_id,
      });

      setRows(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Manager Queue Error:", error);
      alert(error?.response?.data?.error || "Failed to load manager queue");
    } finally {
      setLoading(false);
    }
  }

  const filteredRows = useMemo(() => {
    const q = search.trim().toLowerCase();

    if (!q) return rows;

    return rows.filter((row) =>
      [
        row.code,
        row.title,
        row.requester,
        row.total_amount,
        row.submitted_at,
      ]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(q))
    );
  }, [rows, search]);

  const totalPages = Math.max(
    1,
    Math.ceil(filteredRows.length / rowsPerPage)
  );

  const pageClamped = Math.min(
    Math.max(page, 1),
    totalPages
  );

  const pageData = useMemo(() => {
    const start = (pageClamped - 1) * rowsPerPage;
    return filteredRows.slice(start, start + rowsPerPage);
  }, [filteredRows, pageClamped, rowsPerPage]);

  const totalAmount = useMemo(() => {
    return filteredRows.reduce(
      (sum, row) => sum + Number(row.total_amount || 0),
      0
    );
  }, [filteredRows]);

  const openActionModal = (id, type) => {
    const titleMap = {
      approve: "Approve Report",
      request: "Request Changes",
      reject: "Reject Report",
    };

    setActionModal({
      show: true,
      id,
      type,
      title: titleMap[type] || "Confirm Action",
    });
  };

  const closeActionModal = () => {
    setActionModal({
      show: false,
      id: null,
      type: "",
      title: "",
    });
  };

  async function confirmAction() {
    const { id, type } = actionModal;

    if (!id || !type) return;

    try {
      setSaving(true);

      if (type === "approve") {
        await managerApprove(id, {
          actor_id: fakeManager.id,
          comment,
        });
      }

      if (type === "request") {
        await managerReqChg(id, {
          actor_id: fakeManager.id,
          comment: comment || "Please correct details",
        });
      }

      if (type === "reject") {
        await managerReject(id, {
          actor_id: fakeManager.id,
          comment: comment || "Not acceptable",
        });
      }

      setComment("");
      closeActionModal();
      await load();

      alert("Action completed successfully");
    } catch (error) {
      console.error("Manager Action Error:", error);
      alert(error?.response?.data?.error || "Failed to complete action");
    } finally {
      setSaving(false);
    }
  }

  const exportCSV = () => {
    if (!filteredRows.length) {
      alert("No data available to export");
      return;
    }

    const headers = [
      "ID",
      "Code",
      "Title",
      "Requester",
      "Total Amount",
      "Submitted At",
    ];

    const csvRows = filteredRows.map((row) => [
      row.id,
      row.code,
      row.title,
      row.requester,
      Number(row.total_amount || 0).toFixed(2),
      row.submitted_at
        ? new Date(row.submitted_at).toLocaleString()
        : "-",
    ]);

    const csvContent = [headers, ...csvRows]
      .map((row) =>
        row
          .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "manager-queue.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const clearFilters = () => {
    setSearch("");
    setComment("");
    setRowsPerPage(10);
    setPage(1);
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString();
  };

  const summaryCards = [
    {
      label: "Total Pending",
      value: rows.length,
      icon: "fa-solid fa-hourglass-half",
      className: "acct-mq-stat-orange",
    },
    {
      label: "Filtered Result",
      value: filteredRows.length,
      icon: "fa-solid fa-filter",
      className: "acct-mq-stat-purple",
    },
    {
      label: "Total Amount",
      value: `₹${totalAmount.toFixed(2)}`,
      icon: "fa-solid fa-indian-rupee-sign",
      className: "acct-mq-stat-blue",
    },
    {
      label: "Current Page",
      value: pageClamped,
      icon: "fa-regular fa-file-lines",
      className: "acct-mq-stat-green",
    },
  ];

  const modalIcon =
    actionModal.type === "approve"
      ? "fa-solid fa-circle-check"
      : actionModal.type === "reject"
      ? "fa-solid fa-circle-xmark"
      : "fa-solid fa-pen-to-square";

  return (
    <div className="unit-page acct-managerqueue-theme">
      <div className="acct-mq-heading-box">
        <div className="acct-mq-heading-content">
          <div className="acct-mq-heading-icon">
            <i className="fa-solid fa-user-check"></i>
          </div>

          <div>
            <div className="unit-page-label">Accounts Approval</div>
            <h2>Manager Queue</h2>
            <p>
              Review submitted reports, approve them, request changes or reject.
            </p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button
            className="unit-btn unit-btn-light"
            onClick={load}
            disabled={loading}
          >
            <i
              className={`fa-solid fa-arrows-rotate ${
                loading ? "fa-spin" : ""
              }`}
            ></i>
            Refresh
          </Button>

          <Button
            className="unit-btn unit-btn-light"
            onClick={exportCSV}
          >
            <i className="fa-solid fa-file-csv"></i>
            Export CSV
          </Button>
        </div>
      </div>

      <div className="unit-stats-row">
        {summaryCards.map((item) => (
          <div
            key={item.label}
            className={`unit-stat-card ${item.className}`}
          >
            <div className="acct-mq-stat-content">
              <div className="acct-mq-stat-copy">
                <span>{item.label}</span>
                <strong>{item.value}</strong>
              </div>

              <div className="acct-mq-stat-icon">
                <i className={item.icon}></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="acct-mq-section-title">
            <div className="acct-mq-section-icon">
              <i className="fa-solid fa-list-check"></i>
            </div>

            <div>
              <h5>Pending Reports</h5>
              <p>
                Search reports, add a comment, and perform approval actions.
              </p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <InputGroup className="unit-search">
              <InputGroup.Text>
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>

              <Form.Control
                placeholder="Search code, title, requester, amount..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => setSearch("")}
                  title="Clear search"
                >
                  <i className="fa-solid fa-xmark"></i>
                </Button>
              )}
            </InputGroup>

            <Form.Select
              className="unit-page-size"
              value={rowsPerPage}
              onChange={(e) =>
                setRowsPerPage(Number(e.target.value))
              }
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>

            {(search || comment || rowsPerPage !== 10) && (
              <Button
                className="unit-btn unit-btn-light"
                onClick={clearFilters}
              >
                <i className="fa-solid fa-rotate-left"></i>
                Reset
              </Button>
            )}
          </div>
        </div>

        <div className="acct-mq-comment-panel">
          <div className="acct-mq-comment-icon">
            <i className="fa-regular fa-message"></i>
          </div>

          <Form.Group className="acct-mq-comment-group">
            <Form.Label>Comment for Next Action</Form.Label>

            <Form.Control
              placeholder="Optional comment for approve / request changes / reject..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />

            <small>
              <i className="fa-solid fa-circle-info"></i>
              This comment will be sent with the action you choose.
            </small>
          </Form.Group>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading manager queue...</p>
            </div>
          ) : (
            <table className="table unit-table">
              <thead>
                <tr>
                  <th style={{ width: "90px" }}>Code</th>
                  <th>Report</th>
                  <th>Requester</th>
                  <th>Total</th>
                  <th>Submitted</th>
                  <th className="text-end" style={{ width: "300px" }}>
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {pageData.length > 0 ? (
                  pageData.map((row) => (
                    <tr key={row.id}>
                      <td>
                        <span className="unit-id">
                          {row.code || `#${row.id}`}
                        </span>
                      </td>

                      <td>
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {row.title?.charAt(0)?.toUpperCase() || "R"}
                          </div>

                          <div className="unit-name-copy">
                            <Link
                              to={`/admin/accounts/reports/${row.id}`}
                              className="text-decoration-none"
                            >
                              <strong>{row.title || "-"}</strong>
                            </Link>

                            <small>
                              <i className="fa-solid fa-hashtag"></i>
                              Report ID: {row.id}
                            </small>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span className="acct-mq-requester">
                          <i className="fa-regular fa-user"></i>
                          {row.requester || "-"}
                        </span>
                      </td>

                      <td>
                        <span className="unit-amount">
                          ₹{Number(row.total_amount || 0).toFixed(2)}
                        </span>
                      </td>

                      <td>
                        <span className="unit-date">
                          <i className="fa-regular fa-calendar"></i>
                          {formatDate(row.submitted_at)}
                        </span>
                      </td>

                      <td>
                        <div className="unit-actions">
                          <Button
                            className="unit-btn unit-btn-approve"
                            onClick={() =>
                              openActionModal(row.id, "approve")
                            }
                          >
                            <i className="fa-solid fa-check"></i>
                            Approve
                          </Button>

                          <Button
                            className="unit-btn unit-btn-changes"
                            onClick={() =>
                              openActionModal(row.id, "request")
                            }
                          >
                            <i className="fa-solid fa-pen"></i>
                            Changes
                          </Button>

                          <Button
                            className="unit-btn unit-btn-danger"
                            onClick={() =>
                              openActionModal(row.id, "reject")
                            }
                          >
                            <i className="fa-solid fa-xmark"></i>
                            Reject
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-inbox"></i>
                        </div>
                        <h5>No pending reports</h5>
                        <p>
                          There are no reports waiting for manager review.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing{" "}
            <strong>
              {filteredRows.length === 0
                ? 0
                : (pageClamped - 1) * rowsPerPage + 1}
            </strong>{" "}
            to{" "}
            <strong>
              {Math.min(
                pageClamped * rowsPerPage,
                filteredRows.length
              )}
            </strong>{" "}
            of <strong>{filteredRows.length}</strong> entries
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={pageClamped === 1}
                onClick={() =>
                  setPage((prev) => Math.max(1, prev - 1))
                }
              />

              {compactPageItems([...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === pageClamped}
                  onClick={() => setPage(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              )), pageClamped)}

              <Pagination.Next
                disabled={pageClamped === totalPages}
                onClick={() =>
                  setPage((prev) =>
                    Math.min(totalPages, prev + 1)
                  )
                }
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={actionModal.show}
        onHide={closeActionModal}
        centered
        className={`unit-modal acct-mq-action-modal acct-mq-modal-${actionModal.type}`}
      >
        <Modal.Header closeButton>
          <div className="acct-mq-modal-heading">
            <div className="acct-mq-modal-icon">
              <i className={modalIcon}></i>
            </div>

            <div>
              <small>Manager Action</small>
              <Modal.Title>{actionModal.title}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <p className="unit-delete-text">
            Are you sure you want to continue with this action?
          </p>

          <Form.Group className="mt-3">
            <Form.Label>Comment</Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Add comment..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="unit-btn unit-btn-light"
            onClick={closeActionModal}
            disabled={saving}
          >
            <i className="fa-solid fa-arrow-left"></i>
            Cancel
          </Button>

          <Button
            className={
              actionModal.type === "reject"
                ? "unit-btn unit-btn-danger"
                : actionModal.type === "request"
                ? "unit-btn unit-btn-changes"
                : "unit-btn unit-btn-approve"
            }
            onClick={confirmAction}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i
                  className={
                    actionModal.type === "reject"
                      ? "fa-solid fa-xmark"
                      : actionModal.type === "request"
                      ? "fa-solid fa-pen"
                      : "fa-solid fa-check"
                  }
                ></i>
                Confirm
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}